import { isString } from 'lodash';

import S from 'constants/string.const';
import asArray from 'utils/arrays/asArray.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromObjectToEntries from 'utils/converters/object/fromObjectToEntries.util';
import isMissing from 'utils/predicates/any/isMissing.util';

const fromAnyToDescription = (value) => fromAnyToTrimmed(value) || S.minus;

const fromAnyToOption = (item) => {
  const { value, description, ...extra } = item ?? {};

  if (isMissing(description) && isMissing(value)) {
    const both = isMissing(item) ? S.minus : item;
    return { ...extra, value: both, description: both };
  }

  return {
    ...extra,
    value,
    description: isMissing(description) ? fromAnyToDescription(value) : description,
  };
};

const fromEntryToOption = ([value, description]) => ({
  // will be using the object keys as values and whatever value they hold as the description to display
  value,
  description: isMissing(description) ? fromAnyToTrimmed(value) || S.minus : description,
});

const canonicalizeSelectOptions = (item) => {
  if ('' === item || null === item || void 1 === item) return asArray();

  if (Array.isArray(item)) return item.map(fromAnyToOption);

  if (Number.isFinite(item)) return [{ description: String(item), value: item }];
  if (isString(item)) return [{ description: item, value: item }];

  const entries = fromObjectToEntries(item ?? {});

  // the same frozen empty array to limit possible re-renders and sharing problems if it is passed to other component
  if (!entries.length) return asArray();

  return entries.map(([description, value]) => fromEntryToOption([value, description]));
};

// noinspection JSUnusedGlobalSymbols
export default canonicalizeSelectOptions;
